// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "3409dfbd3759a05a" + ".js";
};